<template>
  <div class="flex column" style="width: 100vm" v-title data-title="其他问题">
    <div v-for="(data, index) in list" :key="index">
      <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
        <div class="flex main-space-between cross-center" style="height: 49px;">
          <span>{{index + 1}}.{{data.title}}</span>
          <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
        </div>
        <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutStudentMember",
    data () {
      return{
        list: [
          {
            title: '阅伴VIP会员是什么？',
            detailTexts: [{title: '阅伴VIP会员分为普通会员和超级会员。', img: require('../assets/student_member_type.png')}]
          },
          {
            title: '会员价格是多少？',
            detailTexts: [{img: require('../assets/student_member_price.png')}]
          },
          {
            title: '如何购买会员？',
            detailTexts: [{title: '在“我的"页面中，点击“会员中心"，选择要购买的会员类型和套餐，按照流程操作即可。'}]
          },
          {
            title: '如何使用会员权益？',
            detailTexts: [{title: '1.赠送20组价值800元的阅读课程：视频试看结束后用会员权益解锁课程。'},
              {title: '2.登录送阅芽：会员用户每日首次打开App系统会自动赠送片阅芽。'},
              {title: '3.重复闯关不扣阅芽：会员在重复闯关时，系统自动使用权益次数，权益使用完毕以后，再次重复闯关会继续扣除阅芽。'},
              {title: '4.查看错题不扣阅芽：会员在查看错题提时，系统自动使用权益次数，普通会员和超级会员均有2次/天，权益使用完毕以后，再次查看错题会继续扣除阅芽。'}]
          },
          {
            title: '会员即将到期如何续费？',
            detailTexts: [{title: '会员用户可在“会员中心”点击右上角的“续费”按钮，即可续费。'}]
          },
          {
            title: '普通会员能够升级超级会员吗？',
            detailTexts: [{title: '暂不支持普通会员升级为超级会员。需等普通会员到期后，选择购买超级会员。'}]
          }
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutStudentMember.vue